import { CompanyIcon } from '@/components/CompanyIcon';
import PencilOutline from '@simplywallst/ui-core/icons/PencilOutline';

type Props = {
  onCompanySelect: () => void;
  companyName: string;
  tickerSymbol: string;
  website: string | undefined | null;
};

export const NarrativeMiniValuatorCompanySelector = ({
  onCompanySelect,
  companyName,
  tickerSymbol,
  website,
}: Props) => {
  return (
    <button
      type="button"
      className="group focus-outline grid grid-cols-[max-content_max-content_max-content_auto_1fr] items-center rounded-x0_5 text-solid"
      onClick={onCompanySelect}
    >
      <h3 className="m-0 pr-x1_5 text-xs font-normal">Your Valuation for</h3>
      <CompanyIcon website={website} tickerSymbol={tickerSymbol} size={20} />
      <div className="pl-x0_75 text-xs font-bold">{tickerSymbol}</div>
      <div className="truncate px-x0_5 text-xs text-softer transition-colors group-hover:text-solid">
        {companyName}
      </div>
      <PencilOutline className="size-x3 fill-softer transition-colors group-hover:fill-solid" />
    </button>
  );
};
